import {useState} from "react";

const useHandleDirtyFieldsModal = (
  resetField: () => void,
  handleOpenVoyageModal: () => void,
) => {
  const [openWarningDirtyFields, setOpenWarningDirtyFields] =
    useState<boolean>(false);

  const handleOpenWarningDirtyFields = () => {
    setOpenWarningDirtyFields(true);
  };

  const handleCloseWarningDirtyFields = () => {
    setOpenWarningDirtyFields(false);
  };

  const handleConfirmWarningDirtyFields = () => {
    resetField();
    handleCloseWarningDirtyFields();
    handleOpenVoyageModal();
  };

  return {
    openWarningDirtyFields,
    handleOpenWarningDirtyFields,
    handleCloseWarningDirtyFields,
    handleConfirmWarningDirtyFields,
  };
};

export default useHandleDirtyFieldsModal;
